module.exports = __webpack_public_path__ + "img/avatar-rd.e718cc1e.svg";